import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { SnackbarMessages } from "./Snackbar.jsx";
// import TranslationSwitcher from "../components/TranslationSwitcher";

const LoginLayout = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "common.white",
        position: "relative",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
          position: "relative",
        }}
      >
        <Paper
          sx={{
            p: 4,
            maxWidth: 500,
            width: "100%",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "8px",
          }}
        >
          {children}
        </Paper>
        <Box
          sx={{
            position: "absolute",
            bottom: 16,
            textAlign: "center",
            width: "100%",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: "#9EA8C3", fontSize: "1rem" }}
          >
            &copy; {new Date().getFullYear()} Svět rovnátek. All Rights
            Reserved.
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "primary.dark",
          color: "white",
          flexDirection: "column",
          px: 4,
          userSelect: "none",
          caretColor: "transparent",
        }}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
      >
        <img
          src="/img/logo.svg"
          alt="Svět rovnátek logo"
          style={{
            maxWidth: "200px",
          }}
        />
      </Box>

      {/*<Box sx={{ position: "absolute", bottom: 16, left: 16 }}>*/}
      {/*  <TranslationSwitcher />*/}
      {/*</Box>*/}
      <SnackbarMessages />
    </Box>
  );
};

export default LoginLayout;
